import Vue from "vue";
window._ = require("lodash");
var numeral = require("numeral");
window.Filter = require("bad-words");
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import Input from "@/components/Input";
import Rtextarea from "@/components/Rtextarea";
import Rupload from "@/components/Rupload";

import VideoItem from "@/components/VideoItem";
import Comments from "@/components/Comments";
import ArticleEdit from "@/components/ArticleEdit";
import Skeleton from "@/components/Skeleton";
import Skeletonlist from "@/components/Skeletonlist";
import Skeletonlistpic from "@/components/Skeletonlistpic";
import Vuetify from "vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
// import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
// import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "@/assets/css/app.scss";
// import "@/core/plugins/formvalidation";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "vue-multiselect-listbox/dist/vue-multi-select-listbox.css";
import vMultiselectListbox from "vue-multiselect-listbox";
import VueElementLoading from "vue-element-loading";
import VueSession from "vue-session";
// import VueTree from '@ssthouse/vue-tree-chart'
import { AgGridVue } from "ag-grid-vue";
import VueCoreVideoPlayer from "vue-core-video-player";
import VueTagsInput from "@johmun/vue-tags-input";
import VueMaterial from "vue-material";
import RouterTab from "vue-router-tab";
import "vue-router-tab/dist/lib/vue-router-tab.css";

 
import VueGridDesigner from '@thefoot/vue-grid-designer';
Vue.component('vue-grid-designer', VueGridDesigner);


Vue.use(VueMaterial);

Vue.component("video-item", VideoItem);
Vue.component("vue-tags-input", VueTagsInput);
Vue.component("Rinput", Input);
Vue.component("Rtextarea", Rtextarea);
Vue.component("Rupload", Rupload);
Vue.component("ag-grid-vue", AgGridVue);
// Vue.component('vue-tree', VueTree)
Vue.component("ArticleEdit", ArticleEdit);
Vue.component("Comments", Comments);
Vue.component("Skeletonlist", Skeletonlist);
Vue.component("Skeletonlistpic", Skeletonlistpic);
Vue.component("Skeleton", Skeleton);

Vue.use(RouterTab);
Vue.use(VueSession, { persist: true });
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";

const favideo = {
  dashboard: {
    btn: {
      play: "پخش",
      pause: "توقف",
      fullscreen: "تمام صفحه",
      exitFullscreen: "خروج از تمام صفحه",
      mute: "بی صدا",
      unmute: "با صدا",
      back: "برگشت",
      pip: "تصویر در تصویر"
    },
    settings: {
      autoplay: "پشخ خودکار",
      loop: "تکرار",
      speed: "سرعت",
      resolution: "اندازه تصویر"
    }
  },
  layers: {
    error: {
      title: "خطا",
      2404: "ویدئو یافت نشد",
      2502: "خطا در شبکه",
      2503: "مشکل در پخش کدک های فایل",
      2504: "امکان پخش فایل وجود ندارد"
    },
    loading: {
      msg: "لطفا صبر کنید ..."
    }
  }
};

Vue.use(VueCoreVideoPlayer, {
  lang: favideo
});

import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
Vue.component("date-picker", VuePersianDatetimePicker);

import fa from "vee-validate/dist/locale/fa.json";
import * as rules from "vee-validate/dist/rules";

import VTooltip from "v-tooltip";

Vue.use(VTooltip);

import "vue-easytable/libs/theme-default/index.css"; // import style
import VueEasytable from "vue-easytable"; // import library
import "./plugins/element.js";

import vmodal from "vue-js-modal";
import Vuesax from "vuesax";

import "vuesax/dist/vuesax.css";
Vue.use(Vuesax, {
  rtl: true
});
import VueUploadComponent from "vue-upload-component";

Vue.component("file-upload", VueUploadComponent);
Vue.use(vmodal);
Vue.use(VueEasytable);

Vue.component("VueElementLoading", VueElementLoading);
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

localize("fa", fa);

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

// API service init
ApiService.init();

// Remove this to disable mock API
//MockService.init();

router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

Vue.use(Vuetify, {
  rtl: true
});

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

Vue.directive("can", {
  bind: function (el, binding, vnode) {
    // console.log("bind");
    // console.log(el);
    // console.log(binding);
    // console.log(vnode);
    // console.log(binding.value);
    // console.log(binding.value.length);
    let Permission = Vue.prototype.$session.get("permissions");
    //  console.log(Permission);

    if (binding.value.length > 0 && Permission != null) {
      let perexis = 0;
      binding.value.forEach(function (item) {
        let per = Permission.includes(item);
        if (per) {
          perexis = perexis + 1;
        }
      });
      if (perexis == 0) {
        //el.style.visibility = "hidden";
        let elm = vnode.elm;
        while (elm.firstChild) {
          elm.removeChild(elm.lastChild);
        }
      }
    } else {
      let elm = vnode.elm;
      while (elm.firstChild) {
        elm.removeChild(elm.lastChild);
      }
    }
  },
  inserted: function (el, binding, vnode) {
    // console.log("inserted");
    // console.log(el);
    // console.log(binding);
    // console.log(vnode);
    // console.log(binding.value);
    // console.log(binding.value.length);
    let Permission = Vue.prototype.$session.get("permissions");
    //  console.log(Permission);

    if (binding.value.length > 0 && Permission != null) {
      let perexis = 0;
      binding.value.forEach(function (item) {
        let per = Permission.includes(item);
        if (per) {
          perexis = perexis + 1;
        }
      });
      if (perexis == 0) {
        //el.style.visibility = "hidden";
        let elm = vnode.elm;
        while (elm.firstChild) {
          elm.removeChild(elm.lastChild);
        }
      }
    } else {
      let elm = vnode.elm;
      while (elm.firstChild) {
        elm.removeChild(elm.lastChild);
      }
    }
  },

  update: function (el, binding, vnode) {
    // console.log("update");
    // console.log(binding);
    // console.log(vnode);
    // console.log(binding.value);
    // console.log(binding.value.length);
    let Permission = Vue.prototype.$session.get("permissions");
    //console.log(Permission);

    if (binding.value.length > 0 && Permission != null) {
      let perexis = 0;
      binding.value.forEach(function (item) {
        let per = Permission.includes(item);
        if (per) {
          perexis = perexis + 1;
        }
      });
      if (perexis == 0) {
        //el.style.visibility = "hidden";
        let elm = vnode.elm;
        while (elm.firstChild) {
          elm.removeChild(elm.lastChild);
        }
      }
    } else {
      let elm = vnode.elm;
      while (elm.firstChild) {
        elm.removeChild(elm.lastChild);
      }
    }
  }
});

import "vue-js-modal/dist/styles.css";

Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
});

Vue.component("v-multiselect-listbox", vMultiselectListbox);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
